import { SingleOrArray } from "@dirootie-extensions/typescript";
import { IRootieComponent } from "../_types";

export const createDynamicComponent = ({component, componentEl, props = {}, ...rest}:{component: any, props?: any, componentEl?: any}) => {
  if(componentEl) {
    return componentEl;
  }
  if(component) {
    const LayoutComponent = component as any;
    const result = <LayoutComponent {...props} {...rest}/>;
    return result;
  }
  return <><p>No component nor element exists.</p></>
}

export const createRootieComponent = ({Component,key, props, ...rest}:IRootieComponent<any>) => {
  if(Component) {
    const result = <Component key={key} {...props} {...rest}/>;
    return result;
  }
  return <><p>No component nor element exists.</p></>
}

export const createComponentForRouter = (configs: SingleOrArray[]): React.ReactElement | null => {
  const build = (index: number): React.ReactElement | null => {
    if (index < 0) return null; // Base case: no more components to process

    const { component: Component, props } = configs[index];
    const children = build(index - 1); // Recursive call: build child components

    return <Component key={index} {...props}>{children}</Component>;
  };

  return build(configs.length - 1); // Start from the last element
};
